import * as React from "react";
import { useRoutes } from "react-router-dom";
import UserDetailsComponent from "./pages/userdetails";
import ThankYou from "./pages/thank-you";
import InReview from "./pages/in-review";
import AdmissionDecision from "./pages/admission-decision";
import Withdrawn from "./pages/withdrawn";
import LoginComponent from "./pages/login";

function Route() {
  let element = useRoutes([
    { path: "/", element: <LoginComponent /> },
    { path: "/user-details", element: <UserDetailsComponent /> },
    { path: "/thank-you", element: <ThankYou /> },
    { path: "/in-review", element: <InReview /> },
    { path: "/admission-decision", element: <AdmissionDecision /> },
    { path: "/withdrawn", element: <Withdrawn /> },
  ]);

  return element;
}
const App = () => {
  return (<>
    <Route />
  </>)
}
export default App
